import { CampaignDtoToEntity } from "src/app/features/Campaign/services/mappers/CampaignDtoToEntity";
import type { CampaignDto } from "src/app/features/Campaign/types/CampaignDto";
import type { CampaignEntity } from "src/app/features/Campaign/types/CampaignEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const CampaignTableDtoMapper = (input: Readonly<ResourcePageDto<CampaignDto>>): ResourcePageEntity<CampaignEntity> => {
    return {
        list: input.list ? input.list.map(CampaignDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
